export default __webpack_public_path__ + "static/IBMPlexMono700-ff37a59dc73f12394b031fbae151f0ac.woff2";